/*
 * @Author: zhanghuawei zhanghuawei@shengpay.com
 * @Date: 2024-02-27 13:25:11
 * @LastEditors: zhanghuawei zhanghuawei@shengpay.com
 * @LastEditTime: 2024-03-11 15:24:36
 * @FilePath: /merchant-platform/packages/api/src/axios/sdpFund copy.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { AxiosRequestConfig } from 'axios'
import type { RequestOptions } from '@mp/http-axios'
import { createAxios } from './index'

// #region mch trade data request start
export const defHttp = createAxios({
  requestOptions: {
    // 接口地址
    apiUrl: window.location.origin,
    // 接口拼接地址
    urlPrefix: '/mchgateway/sdpsecurity',
  },
})

export function request<T>(url: string, options: AxiosRequestConfig & { customOptions?: RequestOptions }): Promise<T> {
  const { customOptions } = options || {}
  // TODO:需要注释掉
  // if (!options.headers)
  // options.headers = { userInfo: '{"operatorId":"7000015121435","operatorName":"%E4%B8%8A%E6%B5%B7%E7%A8%9A%E9%BE%84%E5%81%A5%E5%BA%B7%E7%AE%A1%E7%90%86%E5%92%A8%E8%AF%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8","operatorPrincipal":"merchant","operatorType":"default","agentId":"706483","merchantId":"93762223","memberId":"203100000000000126036684"}' }
  return defHttp.request({ ...options, url }, customOptions)
}
// #endregion mch trade data request end
